let CustomMealDrawer = (function () {
  function CustomMealDrawer(container) {
    this._inTransaction = false;
    this.container = container;
    this.meals = [];
    this.selectors = {
      mealSelectors: ".meal-selectors",
      drawerMealsWrapper: "#custom-meal-drawer .drawer-meals-wrapper",
      repeatMealButton: ".meal-selector-controls .btn.repeat-meal",
      currentMealCounter: ".current-meal-amount",
      totalProtein: ".cm-macros__info [data-macros__total-protein]",
      totalCalories: ".cm-macros__info [data-macros__total-cal]",
      totalFats: ".cm-macros__info [data-macros__total-fat]",
      totalCarbs: ".cm-macros__info [data-macros__total-carb]",
      totalCost: ".drawer-meal-total [data-total-cost]",
      removeButton: ".remove-meal",
      drawerCollapsed: ".meal-progress",
      checkoutButton: ".btn.checkout",
      deliveryDate: "#deliveryDate",
      addToCartBtn: ".add-to-cart-btn",
      builderMealContainer: ".meal-selectors",
      quantityState: ".quantity-state",
      addState: ".add-state",
      quantityPlus: ".quantity-btn.plus",
      quantityMinus: ".quantity-btn.minus",
      quantityValue: ".meal-quantity",
      cartActionWrapper: ".cart-action-wrapper",
      errorText:  ".error"
    };
    this.builderContainer = document.querySelector(
      this.selectors.builderMealContainer
    );
    this.totalPrice = 0;
    this.loadMealsFormStorage();
    this.updateCurrentMealCounters();
    this.updateTotalMealMetrics();
    this.calcTotalPrice();
    this.bindCallbacks();
    this.bindEvents();
    this.collapseDrawer();
    this.setDeliveryDate();
  }

  CustomMealDrawer.prototype = {
    _startTransaction: function () {
      if (this._inTransaction) return false;
      this._inTransaction = true;
      return true;
    },

    _endTransaction: function () {
      this._inTransaction = false;
    },

    bindEvents: function () {
      this.container
        .querySelectorAll(this.selectors.removeButton)
        .forEach((removeButton) => {
          removeButton.addEventListener("click", () => {
            const mealComponent = {
              name: removeButton
                .closest(".drawer-meal__content")
                .getAttribute("data-meal-name"),
            };
            const componentType = removeButton
              .closest(".drawer-meal__content")
              .getAttribute("data-meal-type");
            this.removeMeal(mealComponent, componentType);
          });
        });
      this.container
        .querySelector(this.selectors.drawerCollapsed)
        .addEventListener("click", this.drawerCollapsedBound, false);
      this.container
        .querySelectorAll(this.selectors.checkoutButton)
        .forEach((checkoutButton) => {
          checkoutButton.addEventListener(
            "click",
            () => this.addMealToCart(),
            false
          );
        });
      this.builderContainer
        .querySelectorAll(this.selectors.addToCartBtn)
        .forEach((btn) => {
          btn.addEventListener("click", this.addToCartBound, false);
        });

      document.addEventListener("click", (e) => {
        if (e.target.matches(".quantity-btn.plus")) {
          this.quantityPlusBound(e);
        } else if (e.target.matches(".quantity-btn.minus")) {
          this.quantityMinusBound(e);
        }
      });
    },
    createMealComponent: function (data) {
      return {
        name: data.option || data.mealName,
        protein: data.protein,
        fat: data.fat,
        carb: data.carb,
        calories: data.cal,
        price: data.price,
        variantId: data.variant,
      };
    },

    updateQuantityUI: function (optionCard, show, value = null) {
      const cartWrapper = optionCard.querySelector(
        this.selectors.cartActionWrapper
      );
      cartWrapper.querySelector(this.selectors.addState).style.display = show
        ? "none"
        : "flex";
      cartWrapper.querySelector(this.selectors.quantityState).style.display =
        show ? "flex" : "none";

      if (value !== null) {
        cartWrapper.querySelector(this.selectors.quantityValue).textContent =
          value;
      }
    },
    toggleHeaderState: function (componentType, isActive) {
      const accordionHeader = document
        .querySelector(`.option.${componentType}`)
        ?.closest(".option-wrapper")
        ?.querySelector(".accordion-header");

      if (accordionHeader) {
        const headerH4 = accordionHeader.querySelector("h4");
        if (isActive) {
          accordionHeader.classList.add("active");
          headerH4?.classList.add("active");
        } else {
          accordionHeader.classList.remove("active");
          headerH4?.classList.remove("active");
        }
      }
    },

    updateDrawerQuantity: function (mealName, componentType, quantity) {
      const drawerCard = document.querySelector(
        `.drawer-meal__content[data-meal-name="${mealName}"][data-meal-type="${componentType}"]`
      );
      if (drawerCard) {
        drawerCard.querySelector(".meal-quantity").textContent = quantity;
        drawerCard.querySelector(".drawer-meal-choice__price").textContent =
          parseFloat(drawerCard.dataset.price * quantity).toFixed(2);
      }
    },
    updateAllMetrics: function () {
      this.updateMealsInStorage();
      this.updateTotalMealMetrics();
      this.updateCurrentMealCounters();
      this.calcTotalPrice();
    },

    bindCallbacks: function () {
      this.removeButtonBound = (evt) => this.removeMeal(evt);
      this.drawerCollapsedBound = (evt) => this.collapseDrawer(evt);

      this.addToCartBound = (evt) => {
        const mealComponent = this.createMealComponent(
          evt.currentTarget.dataset
        );
        const componentType = evt.currentTarget
          .closest(".option")
          .classList.contains("protein")
          ? "protein"
          : evt.currentTarget.closest(".option").classList.contains("carb")
          ? "carb"
          : evt.currentTarget.closest(".option").classList.contains("veg")
          ? "veg"
          : null;

        this.handleItemQuantityChange(mealComponent, componentType, "add");
      };

      this.quantityPlusBound = (evt) => {
        const { mealComponent, componentType } = this.getMealComponentData(evt);
        this.handleItemQuantityChange(mealComponent, componentType, "add");
      };

      this.quantityMinusBound = (evt) => {
        const { mealComponent, componentType } = this.getMealComponentData(evt);
        this.handleItemQuantityChange(mealComponent, componentType, "remove");
      };
    },

    getMealComponentData: function (evt) {
      let mealComponent = {};
      let componentType;

      if (evt.target.closest(".option")) {
        const optionCard = evt.target.closest(".option");
        const addToCartBtn = optionCard.querySelector(".add-to-cart-btn");

        componentType = optionCard.classList.contains("protein")
          ? "protein"
          : optionCard.classList.contains("carb")
          ? "carb"
          : optionCard.classList.contains("veg")
          ? "veg"
          : null;

        mealComponent = {
          name: addToCartBtn.dataset.option,
          protein: addToCartBtn.dataset.protein,
          fat: addToCartBtn.dataset.fat,
          carb: addToCartBtn.dataset.carb,
          calories: addToCartBtn.dataset.cal,
          price: addToCartBtn.dataset.price,
          variantId: addToCartBtn.dataset.variant,
        };
      } else if (evt.target.closest(".drawer-meal")) {
        const drawerMealContent = evt.target.closest(".drawer-meal__content");
        mealComponent = {
          name: drawerMealContent.dataset.mealName,
          protein: drawerMealContent.dataset.protein,
          fat: drawerMealContent.dataset.fat,
          carb: drawerMealContent.dataset.carb,
          calories: drawerMealContent.dataset.cal,
          price: drawerMealContent.dataset.price,
          variantId: drawerMealContent.dataset.variant,
        };
        componentType = drawerMealContent.dataset.mealType;
      }

      return { mealComponent, componentType };
    },

    addMeal: async function (meal) {
      const existingMeal = this.meals.find(
        (existingMeal) =>
          existingMeal.name === meal.name &&
          existingMeal.componentType === meal.componentType
      );

      const existingCard = document.querySelector(
        `.drawer-meal__content[data-meal-name="${meal.name}"][data-meal-type="${meal.componentType}"]`
      );

      if (existingMeal || existingCard) {
        return;
      }

      
      await this.floatMealToDrawer(meal, this.meals.length);
      this.meals.push(meal);
      this.updateAllMetrics();
    },

    handleItemQuantityChange: function (mealComponent, componentType, action) {
      if (this._inTransaction) return;
      this._startTransaction();
      try {
        const optionCard = document.querySelector(
          `.option.${componentType}:has([data-option="${mealComponent.name}"])`
        );

        const item = this.meals.find(
          (meal) =>
            meal.componentType === componentType &&
            meal.name === mealComponent.name
        );

        if (action === "add") {
          if (!item) {
            const meal = {
              macros: {
                cal: mealComponent.calories,
                carb: mealComponent.carb,
                fats: mealComponent.fat,
                protein: mealComponent.protein,
              },
              name: mealComponent.name,
              componentType: componentType,
              price: mealComponent.price,
              quantity: 1,
              id: mealComponent.variantId,
            };
            console.log(meal);
            this.addMeal(meal);
            this.updateQuantityUI(optionCard, true, 1);
            this.toggleHeaderState(componentType, true);
          } else {
            const newQty = item.quantity + 1;
            item.quantity = newQty;
            this.updateQuantityUI(optionCard, true, newQty);
            this.updateDrawerQuantity(
              mealComponent.name,
              componentType,
              newQty
            );
          }
        } else if (action === "remove" && item) {
          if (item.quantity === 1) {
            this.removeMeal(mealComponent, componentType);

            const hasOtherMeals = this.meals.some(
              (meal) =>
                meal.componentType === componentType &&
                meal.name !== mealComponent.name
            );

            if (!hasOtherMeals) {
              this.toggleHeaderState(componentType, false);
            }
          } else {
            const newQty = item.quantity - 1;
            item.quantity = newQty;

            this.updateQuantityUI(optionCard, true, newQty);
            this.updateDrawerQuantity(
              mealComponent.name,
              componentType,
              newQty
            );
          }
        }

        this.updateAllMetrics();
      } finally {
        this._endTransaction();
      }
    },

    calcTotalPrice: function () {
      this.totalPrice = 0;
      this.meals.forEach((meal) => {
        this.totalPrice += parseFloat(meal.price * meal.quantity);
      });
      this.container.querySelector(this.selectors.totalCost).textContent =
        this.totalPrice.toFixed(2);

      if(this.errorShown){
        if(this.isCheckoutValid()){
          this.hideCheckoutError()
        }
      }
    },

    addMealToCart: function () {
      const checkoutButton = document.querySelector(
        this.selectors.checkoutButton
      );
      if (this.meals.length > 0) {
        checkoutButton.classList.add("loading");
        const spanLoader = checkoutButton.appendChild(
          document.createElement("span")
        );

        spanLoader.classList.add("spinner");
        if(!this.isCheckoutValid()){
          this.throwCheckoutError()
          checkoutButton.classList.remove("loading");
          spanLoader.remove();
          return;
        }
        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ items: this.meals }),
        })
          .then((response) => response.json())
          .then((data) => {
            if (
              data.items &&
              Array.isArray(data.items) &&
              data.items.length > 0
            ) {
              localStorage.removeItem("bulk-meals");
              window.location.href = "/cart";
            } else {
              console.error("Error adding items to cart:", data);
            }
          })
          .catch((error) => {
            console.error("Error:", error);
          })
          .finally(() => {
            checkoutButton.classList.remove("loading");
            spanLoader.remove();
          });
      } else {
        console.error("No valid meals to add to cart.");
      }
    },

    isCheckoutValid: function(){
      return this.totalPrice >= 80
    },

    throwCheckoutError: function(){
        this.container.querySelector(this.selectors.errorText).style.display = 'block';
        this.errorShown = true;
    },
   hideCheckoutError: function(){
      this.container.querySelector(this.selectors.errorText).style.display = 'none';
      this.errorShown = false;

   },
    updateMealsInStorage: function () {
      localStorage.removeItem("bulk-meals");
      localStorage.setItem("bulk-meals", JSON.stringify(this.meals));
    },

    loadMealsFormStorage: function () {
      if (!this._inTransaction) {
        this._startTransaction();
      }
      try {
        const mealsFromStorage = localStorage.getItem("bulk-meals");
        if (mealsFromStorage) {
          this.meals = JSON.parse(mealsFromStorage);

          // Create a Set to track which component types have meals
          const activeComponentTypes = new Set();

          this.meals.forEach((meal, index) => {
            // Add component type to tracking Set
            activeComponentTypes.add(meal.componentType);

            const floatingMeal = this.buildMealEle(meal, index + 1);
            floatingMeal.style.opacity = "1";
            document
              .querySelector(this.selectors.drawerMealsWrapper)
              .appendChild(floatingMeal);
          });

          //Update selector cards with quantity as per the meals in storage
          this.meals.forEach((meal) => {
            const optionCard = document.querySelector(
              `.option.${meal.componentType}:has([data-option="${meal.name}"])`
            );
            const cartWrapper = optionCard.querySelector(
              this.selectors.cartActionWrapper
            );
            cartWrapper.querySelector(this.selectors.addState).style.display =
              "none";
            cartWrapper.querySelector(
              this.selectors.quantityState
            ).style.display = "flex";
            cartWrapper.querySelector(
              this.selectors.quantityValue
            ).textContent = meal.quantity;
          });

          activeComponentTypes.forEach((componentType) => {
            this.toggleHeaderState(componentType, true);
          });
        }
        this.updateAllMetrics();
      } finally {
        this._endTransaction();
      }
    },

    updateCurrentMealCounters: function () {
      document
        .querySelectorAll(this.selectors.currentMealCounter)
        .forEach((counter) => {
          counter.textContent = String(this.meals.length);
        });
    },
    updateTotalMealMetrics: function () {
      this.totalMetrics = {
        calories: 0,
        carbs: 0,
        fats: 0,
        protein: 0,
      };

      this.meals.forEach((meal) => {
        this.totalMetrics.calories += Number(meal.macros.cal * meal.quantity);

        this.totalMetrics.carbs += Number(meal.macros.carb * meal.quantity);

        this.totalMetrics.fats += Number(meal.macros.fats * meal.quantity);

        this.totalMetrics.protein += Number(
          meal.macros.protein * meal.quantity
        );
      });

      // Update the UI with the new totals
      document.querySelector(this.selectors.totalCalories).textContent =
        this.totalMetrics.calories + "g";
      document.querySelector(this.selectors.totalCarbs).textContent =
        String(this.totalMetrics.carbs) + "g";
      document.querySelector(this.selectors.totalFats).textContent =
        String(this.totalMetrics.fats) + "g";
      document.querySelector(this.selectors.totalProtein).textContent =
        String(this.totalMetrics.protein) + "g";
    },
    floatMealToDrawer: function (meal, index) {
      return new Promise((resolve) => {
        // Make it return a promise
        const mealSelectors = document
          .querySelector(this.selectors.mealSelectors)
          .getBoundingClientRect();
        const drawerWrapper = document
          .querySelector(this.selectors.drawerMealsWrapper)
          .getBoundingClientRect();

        // Create a new floating div for the meal
        const floatingMeal = this.buildMealEle(meal, index);

        // Add a temporary class to identify this as an animating meal
        floatingMeal.classList.add("animating-meal");

        document.body.appendChild(floatingMeal);

        floatingMeal.style.position = "absolute";
        floatingMeal.style.left = `${
          mealSelectors.left + window.scrollX + mealSelectors.width / 2
        }px`;
        floatingMeal.style.top = `${
          mealSelectors.top + window.scrollY + mealSelectors.height / 2
        }px`;
        floatingMeal.style.opacity = "0.2";
        floatingMeal.style.transform = "scale(4)";
        floatingMeal.style.transition = "all 1s ease";

        const translateY = drawerWrapper.top - mealSelectors.top;
        const translateX = drawerWrapper.left - mealSelectors.left;

        setTimeout(() => {
          floatingMeal.style.transform = `translate(${translateX}px, ${translateY}px) scale(1)`;
          floatingMeal.style.opacity = "1";
        }, 100);

        setTimeout(() => {
          floatingMeal.classList.remove("animating-meal");
          document
            .querySelector(this.selectors.drawerMealsWrapper)
            .appendChild(floatingMeal);
          floatingMeal.style = "";
          floatingMeal.style.opacity = "1";
          resolve();
        }, 400);
      });
    },

    buildMealEle: function (meal, index) {
      const floatingMeal = document.createElement("div");
      floatingMeal.classList.add("drawer-meal");
      floatingMeal.style = "";

      floatingMeal.innerHTML = `
      <div class="drawer-meal__content" data-meal-type="${
        meal.componentType
      }" data-meal-name="${meal.name}" data-protein="${
        meal.macros.protein
      }" data-carb="${meal.macros.carb}" data-fat="${
        meal.macros.fats
      }" data-cal="${meal.macros.cal}" data-price="${
        meal.price
      }"  data-variant="${meal.variantId}" 
      
      data-meanName="${meal.name}" data-mealType="${meal.componentType}">
            <div class="remove-meal" data-meal-index="${index}" title="Remove Meal" >
                <svg width="11" height="9" viewBox="0 0 11 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.71814 9L5.35982 6.24359L3.28186 9H0.0824588L3.7931 4.42308L0 0H3.28186L5.6072 2.71795L7.65217 0H10.8516L7.17391 4.53846L11 9H7.71814Z" fill="#121212" fill-opacity="0.75"/>
                </svg>
            </div>
            <div class="drawer-meal__title" data-meal-counter="${index}">
                <h4>${meal.name}</h4>
            </div>
            <div class="drawer-meal__macros">
                <p>Protein: <span class="drawer-meal-choice__protein">${
                  meal.macros.protein
                }g</span></p>
                <p>Carb: <span class="drawer-meal-choice__carb">${
                  meal.macros.carb
                }g</span></p>
                <p>Fat: <span class="drawer-meal-choice__fat">${
                  meal.macros.fats
                }g</span></p>
                <p>Cal: <span class="drawer-meal-choice__cal">${
                  meal.macros.cal
                }</span></p>
            </div>
        
            <div class="drawer-meal__price">
                <p>$<span class="drawer-meal-choice__price">${(
                  parseFloat(meal.price) * meal.quantity
                ).toFixed(2)}</span></p>
            </div>

             <div class="quantity-state" >
                    <button class="quantity-btn minus">-</button>
                    <span class="meal-quantity">${meal.quantity}</span>
                    <button class="quantity-btn plus">+</button>
                  </div>
            </div>
       </div>
        `;

      const removeButton = floatingMeal.querySelector(".remove-meal");
      removeButton.addEventListener("click", () => {
        const mealComponent = { name: meal.name };
        const componentType = meal.componentType;
        this.removeMeal(mealComponent, componentType);
      });

      return floatingMeal;
    },
    removeMeal: function (mealComponent, componentType) {
      const mealIndex = this.meals.findIndex(
        (meal) =>
          meal.componentType === componentType &&
          meal.name === mealComponent.name
      );

      if (mealIndex !== -1) {
        this.meals.splice(mealIndex, 1);

        const hasOtherMealsOfType = this.meals.some(
          (meal) => meal.componentType === componentType
        );

        if (!hasOtherMealsOfType) {
          this.toggleHeaderState(componentType, false);
        }

        // Remove from drawer
        const drawerCard = document
          .querySelector(
            `.drawer-meal__content[data-meal-name="${mealComponent.name}"][data-meal-type="${componentType}"]`
          )
          ?.closest(".drawer-meal");
        drawerCard?.remove();

        // Update selector card
        const optionCard = document.querySelector(
          `.option.${componentType}:has([data-option="${mealComponent.name}"])`
        );
        this.updateQuantityUI(optionCard, false);
        this.updateAllMetrics();
      }
    },
    collapseDrawer: function (evt) {
      const drawerMealsWrapper = document.querySelector(
        this.selectors.drawerMealsWrapper
      );
      const arrowIcon = document.querySelector(
        this.selectors.drawerCollapsed + " .arrow-icon"
      );

      drawerMealsWrapper.classList.toggle("collapsed");
      arrowIcon.classList.toggle("rotate");
    },

    setDeliveryDate: function () {
      const savedDate = sessionStorage.getItem("saved_delivery_date");
      if (!savedDate) return;

      updateCartAttributes(savedDate);

      function formatDate(dateString) {
        try {
          const [, month, day, year] = dateString.split(" ");
          const date = new Date(`${month} ${day} ${year}`);
          if (isNaN(date)) return null;

          const yyyy = date.getFullYear();
          const mm = String(date.getMonth() + 1).padStart(2, "0");
          const dd = String(date.getDate()).padStart(2, "0");
          return `${yyyy}-${mm}-${dd}`;
        } catch (error) {
          console.error("Error formatting date:", error);
          return null;
        }
      }

      const deliveryDate = formatDate(savedDate);
      const dateInput = document.querySelector("#deliveryDate");

      if (deliveryDate && dateInput) {
        dateInput.value = deliveryDate;
        dateInput.setAttribute("min", deliveryDate);
      }
    },
  };

  return CustomMealDrawer;
})();

document.addEventListener("DOMContentLoaded", function () {
  const mealDrawer = new CustomMealDrawer(
    document.querySelector("#custom-meal-drawer")
  );
});
